import { render, staticRenderFns } from "./ContractPriceOverview.vue?vue&type=template&id=753f5bf8"
import script from "./ContractPriceOverview.vue?vue&type=script&lang=js"
export * from "./ContractPriceOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports